import axios from 'axios';
import Cookie from 'js-cookie';
import { isProduction } from './utils';
import store from 'app/redux/store';
import md5 from 'md5';

const WEBSITE_GRADER_API_ENDPOINT = 'website_grader';

// ===================
// == api endpoints ==
// ===================
export const searchEndpoint = `${WEBSITE_GRADER_API_ENDPOINT}/new`;

export const pollEndpoint = ref => `${WEBSITE_GRADER_API_ENDPOINT}/poll/${ref}`;

export const leadEndpoint = () => `${WEBSITE_GRADER_API_ENDPOINT}/lead`;

export const getUsfoodCustomerDataEndpoint = () => `${WEBSITE_GRADER_API_ENDPOINT}/get_usfood_customer_data`;

/*
  Self: boolean: whether we want to direct the user to self signup
*/
export const signupEndpoint = (isSelfSignup = false) => {
  const {
    user: { leadSlug, email },
    usFoods,
  } = store.getState();
  const hashedEmail = md5(email);
  // Direct all US Foods traffic to regular signup form
  const dest = isSelfSignup ? 'our-pricing' : 'signup';
  const key = isSelfSignup ? 'slug' : 'lead';
  const hostname = window.location.origin;
  const usf = usFoods || 'false';
  return `${hostname}/${dest}?email=${hashedEmail}&${key}=${leadSlug}&usfoods=${usf}`;
};

// Create an Axios instance
// We need to manually specify if we want to pass cookies during a
// cross-domain request using the `withCredentials` flag.  Currently,
// this is required for making the current user request.
export const createAxios = (withCredentials = false) => {
  // Default persistant headers
  const headers = {
    'Content-Type': 'application/json',
    'X-REQUESTED-With': 'XMLHttpRequest',
  };

  if (isProduction) {
    headers['X-CSRFToken'] = Cookie.get('csrftoken');
  }

  return axios.create({
    headers,
    baseURL: isProduction
      ? `${window.location.origin}/api/`
      : 'https://localtest.me:8000/api/',
    withCredentials,
  });
};
